import { Module } from 'vuex';
import { RootState, ApplicationPaneState, ApplicationPaneKey } from '../types';

const SHOW_LOADING = 'SHOW_LOADING';
const HIDE_LOADING = 'HIDE_LOADING';
const SET_LAST_ERROR = 'SET_LAST_ERROR';
const TOGGLE_PANE = 'TOGGLE_PANE';
const SET_IS_PANE_OPEN = 'SET_IS_PANE_OPEN';
const SET_PANE_CLOSE_TIMEOUT = 'SET_PANE_CLOSE_TIMEOUT';

export const ApplicationPaneActionKeys = {
	openPane: 'openPane',
	closePane: 'closePane',
};

export const ApplicationPaneGetterKeys = {
	pane: 'pane',
	isPaneOpen: 'isPaneOpen',
	loading: 'loading',
	lastError: 'lastError',
};

const initialState: ApplicationPaneState = {
	pane: undefined,
	loading: false,
	lastError: '',
	isPaneOpen: false,
};

const store: Module<ApplicationPaneState, RootState> = {
	namespaced: true,

	state: { ...initialState },

	mutations: {
		[SHOW_LOADING](state) {
			state.loading = true;
		},

		[HIDE_LOADING](state) {
			state.loading = false;
		},

		[SET_LAST_ERROR](state, error) {
			state.lastError = error;
		},

		[TOGGLE_PANE](state, val?: ApplicationPaneKey) {
			state.pane = val;

			if (val) {
				//check if any pending close
				if (state.paneCloseTimeout) {
					clearTimeout(state.paneCloseTimeout);
					state.paneCloseTimeout = undefined;
				}
			}
		},

		[SET_IS_PANE_OPEN](state, val: boolean) {
			state.isPaneOpen = val;
		},

		[SET_PANE_CLOSE_TIMEOUT](state, val?: number) {
			state.paneCloseTimeout = val;
		},
	},

	actions: {
		[ApplicationPaneActionKeys.openPane](
			{ commit },
			{ pane }: { pane: ApplicationPaneKey },
		) {
			commit(SET_IS_PANE_OPEN, true);
			if (!pane) throw new Error('Missing pane key');
			commit(TOGGLE_PANE, pane);
		},
		[ApplicationPaneActionKeys.closePane]({ commit, state }) {
			commit(SET_IS_PANE_OPEN, false);

			// delay 300ms so that application details content still display
			// when closing pane to smooth animation
			if (!state.paneCloseTimeout) {
				const paneCloseTimeout = setTimeout(
					() => commit(TOGGLE_PANE, undefined),
					300,
				);
				commit(SET_PANE_CLOSE_TIMEOUT, paneCloseTimeout);
			}
		},
	},

	getters: {
		[ApplicationPaneGetterKeys.loading]: state => state.loading,
		[ApplicationPaneGetterKeys.lastError]: state => state.lastError,
		[ApplicationPaneGetterKeys.pane]: state => state.pane,
		[ApplicationPaneGetterKeys.isPaneOpen]: state => state.isPaneOpen,
	},
};

export default store;
